import type { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DASHBOARD_PLOT_HEIGHT } from '../../utils/competition-chart';

/** Centered empty copy. Same block on every dashboard card. */
export function DashboardEmptyNote({
  children,
  minHeight = DASHBOARD_PLOT_HEIGHT,
}: {
  children: ReactNode;
  minHeight?: number | string;
}) {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-center w-100 h-100 flex-grow-1 px-4 py-4"
      style={{ minHeight }}
    >
      <span
        className="d-inline-flex align-items-center justify-content-center rounded-circle bg-body-tertiary text-400 mb-3"
        style={{ width: '2.5rem', height: '2.5rem' }}
        aria-hidden
      >
        <FontAwesomeIcon icon="chart-line" className="fs--1" />
      </span>
      <p className="mb-0 fs--1 text-500 lh-base" style={{ maxWidth: '16rem' }}>
        {children}
      </p>
    </div>
  );
}
